var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 18H14.375C14.7917 18 15 18.2083 15 18.625C15 19.0417 14.7917 19.25 14.375 19.25H5.625C5.20833 19.25 5 19.0417 5 18.625C5 18.2083 5.20833 18 5.625 18Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 7.875C15.625 6.38316 15.0324 4.95242 13.9775 3.89752C12.9226 2.84263 11.4918 2.25 10 2.25C8.50816 2.25 7.07742 2.84263 6.02252 3.89752C4.96763 4.95242 4.375 6.38316 4.375 7.875C4.375 10.1825 6.22125 13.19 10 16.7925C13.7788 13.19 15.625 10.1825 15.625 7.875ZM10 18.5C5.41625 14.3337 3.125 10.7913 3.125 7.875C3.125 6.05164 3.84933 4.30295 5.13864 3.01364C6.42795 1.72433 8.17664 1 10 1C11.8234 1 13.572 1.72433 14.8614 3.01364C16.1507 4.30295 16.875 6.05164 16.875 7.875C16.875 10.7913 14.5837 14.3337 10 18.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.75C10.4973 9.75 10.9742 9.55246 11.3258 9.20083C11.6775 8.84919 11.875 8.37228 11.875 7.875C11.875 7.37772 11.6775 6.90081 11.3258 6.54917C10.9742 6.19754 10.4973 6 10 6C9.50272 6 9.02581 6.19754 8.67417 6.54917C8.32254 6.90081 8.125 7.37772 8.125 7.875C8.125 8.37228 8.32254 8.84919 8.67417 9.20083C9.02581 9.55246 9.50272 9.75 10 9.75ZM10 11C9.1712 11 8.37634 10.6708 7.79029 10.0847C7.20424 9.49866 6.875 8.7038 6.875 7.875C6.875 7.0462 7.20424 6.25134 7.79029 5.66529C8.37634 5.07924 9.1712 4.75 10 4.75C10.8288 4.75 11.6237 5.07924 12.2097 5.66529C12.7958 6.25134 13.125 7.0462 13.125 7.875C13.125 8.7038 12.7958 9.49866 12.2097 10.0847C11.6237 10.6708 10.8288 11 10 11Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/location-black.07758fff.svg";
export { ForwardRef as ReactComponent };